import { of } from "rxjs";
import {
  mergeMap,
  groupBy,
  filter,
  distinctUntilKeyChanged,
  switchMap,
  map,
} from "rxjs/operators";

export const TransformSystem = (world, props = {}) => {
  world.data.entity$
    .pipe(
      groupBy(
        (entity) => entity.id,
        (entity) => entity
      ),
      mergeMap((group$) =>
        group$.pipe(
          filter(
            (entity) =>
              entity.hasOwnProperty("object3D") &&
              entity.object3D &&
              entity.hasOwnProperty("transform") &&
              entity.transform
          ),

          // TOOD: combine with: distinctUntilKeyChanged("object3D"),
          distinctUntilKeyChanged("transform"),

          // insert object3D
          switchMap((definition) => {
            if (definition.object3D) {
              return world.object3DManager
                .getObject3D$(definition.object3D)
                .pipe(map((object3D) => ({ definition, object3D })));
            } else {
              return of({ definition });
            }
          })
        )
      )
    )

    .subscribe(({ definition, object3D }) => {
      if (definition && definition.transform && object3D) {
        const { position, rotation, scale } = definition.transform;

        if (Array.isArray(position) && position.length === 3) {
          object3D.position.set(position[0], position[1], position[2]);
        }

        if (Array.isArray(rotation) && rotation.length === 3) {
          object3D.rotation.set(rotation[0], rotation[1], rotation[2]);
        }

        if (Array.isArray(scale) && scale.length === 3) {
          object3D.scale.set(scale[0], scale[1], scale[2]);
        }
      }
    });
};

export default TransformSystem;
